import { voislogApi } from "../utils/apiClients/voislogApi";
import { components } from "../types/voislog_api";

export type MonthlyReport = components["schemas"]["MonthlyReportResponse"];
export type MonthlyReportContent =
  components["schemas"]["MonthlyReportContent"];

/**
 * 月間レポートを取得できる年月一覧(YYYY-MM)を降順で取得する
 * include_current_month は指定しないため、対象は前月まで
 */
export async function fetchMonthlyReportAvailable(): Promise<string[]> {
  const { data } = await voislogApi.GET(
    "/v2/core/report/monthly/available",
    {},
  );
  return data!.year_months;
}

/** 指定した年月(YYYY-MM)の月間レポートを取得する */
export async function fetchMonthlyReport(
  yearMonth: string,
): Promise<MonthlyReport> {
  const { data } = await voislogApi.GET("/v2/core/report/monthly", {
    params: { query: { year_month: yearMonth } },
  });
  return data!;
}
